import React from "react";
import { Link } from "react-router-dom";
import {
    DownBorder,
    LeftItem,
    RightItem,
    TicketContainer,
    UpBorder,
} from "../../../Layouts/TicketStyle";
import { Typography } from "@mui/material";
import { CalendarMonth, Call, LocationOn, Person } from "@mui/icons-material";
import styled from "styled-components";

function SingleTicket({e}) {
    return (
        <TicketContainer sx={{ padding: "10px" }}>
            <Link to={`show/${e?.id}`}>
                <LeftItem>
                    <div>
                        <div className="leftItemData">
                            <CalendarMonth style={{ color: "#358EE1" }} />
                            <Typography
                                style={{ color: "#358ee1", fontWeight: "600" }}
                                className="ticketDetails"
                            >
                                {new Date(e?.lead_date).toLocaleDateString(
                                    "en-US",
                                    {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    }
                                )}
                            </Typography>
                        </div>

                        <div className="leftItemData">
                            <Person />
                            <Typography className="ticketDetails">
                                {e?.client_name}
                            </Typography>
                        </div>
                        <div className="leftItemData">
                            <Call />
                            <Typography className="ticketDetails">
                                {e?.client_phone}
                            </Typography>
                        </div>
                        <div className="leftItemData">
                            <LocationOn />
                            <Typography
                                style={{
                                    marginLeft: "0",
                                    textAlign: "left",
                                }}
                                className="ticketDetails"
                            >
                                {e?.client_address}
                            </Typography>
                        </div>
                        {/* <div className="leftItemData">
            <LocalAtmIcon />
            <Typography className="ticketDetails">Adm</Typography>
          </div> */}
                    </div>

                    <UpBorder></UpBorder>
                    <DownBorder></DownBorder>
                </LeftItem>

                <RightItem>
                    <div>
                        <Typography className="roundedDetal">
                            {e?.opportunity?.custom_service_type}
                        </Typography>
                        <Typography className="status">
                            {e?.financial_status !== "" ? (
                                <>{e?.financial_status}</>
                            ) : (
                                <div style={{ display: "flex" }}>
                                    <p style={{ color: "black" }}>
                                        Financial Situation:{" "}
                                    </p>
                                    <span>
                                        {e?.opportunity
                                            ?.financial_institution == null
                                            ? "cash"
                                            : e?.opportunity
                                                  ?.financial_institution}
                                    </span>
                                </div>
                            )}{" "}
                        </Typography>
                        {/* <Typography className="roundedDetal">
            {" "}
            completed Project certificate Requestd{" "}
          </Typography> */}
                        <Typography className="status">
                            {e?.pm_status}{" "}
                        </Typography>
                        <Typography
                            className="status"
                            style={{ display: "flex" }}
                        >
                            <p style={{ color: "black" }}>Contract amount: </p>
                            <span> ${e?.contract?.cost}</span>
                        </Typography>
                        {e?.opportunity?.goodleap_loan?.status && (
                            <Typography
                                className="status"
                                style={{ display: "flex" }}
                            >
                                <p style={{ color: "black" }}>Status:</p>
                                <span
                                    style={{
                                        fontWeight: "bold",
                                        color: "black",
                                    }}
                                >
                                    {" "}
                                    {e?.opportunity?.goodleap_loan?.status}
                                </span>
                            </Typography>
                        )}
                        {e?.user !== null && (
                            <Typography
                                className="status"
                                style={{ display: "flex" }}
                            >
                                <p style={{ color: "black" }}>Assigned to:</p>
                                <span style={{ fontWeight: "bold" }}>
                                    {" "}
                                    {e?.user?.name}
                                </span>
                            </Typography>
                        )}
                    </div>
                </RightItem>
            </Link>
        </TicketContainer>
    );
}

// const TicketContainer = styled.div`
//     background: #eaeaea;
//     margin: 5px;
// `;

export default SingleTicket;
